import { useEffect, useState } from "react";
import Modal from "../Modal";

/** CERMIN dari backend: src/dos/reject/request.ts (REJECTION_REASON_MAX). */
export const REJECTION_REASON_MAX = 500;

interface DosRejectDialogProps {
  open: boolean;
  dosNo: string;
  submitting: boolean;
  onClose: () => void;
  /** Menerima alasan yang sudah di-trim. */
  onSubmit: (reason: string) => void;
}

export default function DosRejectDialog({
  open,
  dosNo,
  submitting,
  onClose,
  onSubmit,
}: DosRejectDialogProps) {
  const [reason, setReason] = useState("");
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (open) {
      setReason("");
      setTouched(false);
    }
  }, [open]);

  // Sama dengan backend: panjang dihitung setelah trim.
  const length = reason.trim().length;
  const error =
    length === 0
      ? "Rejection reason is required."
      : length > REJECTION_REASON_MAX
        ? `Rejection reason must be at most ${REJECTION_REASON_MAX} characters.`
        : "";
  const showError = Boolean(error) && (touched || length > REJECTION_REASON_MAX);

  return (
    <Modal open={open} title={`Reject DOS ${dosNo}`} onClose={submitting ? () => {} : onClose}>
      <label htmlFor="dos-reject-reason" className="mb-1 block text-sm font-medium text-gray-600">
        Rejection Reason
      </label>
      <textarea
        id="dos-reject-reason"
        value={reason}
        rows={5}
        onChange={(e) => {
          setReason(e.target.value);
          setTouched(true);
        }}
        disabled={submitting}
        className={`w-full rounded-lg border px-3 py-2 text-sm outline-none ${
          showError ? "border-red-400 focus:border-red-500" : "border-gray-200 focus:border-blue-400"
        }`}
      />
      <div className="mt-1 flex justify-between text-xs">
        <span className="text-red-500">{showError ? error : ""}</span>
        <span className={length > REJECTION_REASON_MAX ? "text-red-500" : "text-gray-400"}>
          {length}/{REJECTION_REASON_MAX}
        </span>
      </div>

      <div className="mt-6 flex justify-end gap-3">
        <button
          onClick={onClose}
          disabled={submitting}
          className="rounded-xl border border-gray-200 px-5 py-2.5 font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50">
          Cancel
        </button>
        <button
          onClick={() => onSubmit(reason.trim())}
          disabled={Boolean(error) || submitting}
          className="rounded-xl bg-red-600 px-5 py-2.5 font-medium text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50">
          {submitting ? "Rejecting..." : "Reject"}
        </button>
      </div>
    </Modal>
  );
}
